// extracted by mini-css-extract-plugin
export default {"container":"styles_container__rjbdP","pageWrapper":"styles_pageWrapper__LztKs"};